import './app.css';
import { mount } from 'svelte';
import App from './App.svelte';

const target = document.getElementById('app');
if (!target) throw new Error('#app root not found in index.html');

const app = mount(App, { target });

// PWA update: o registro do sw.js (registerSW.js, injetado no build) nao
// checa atualizacao sozinho enquanto o app fica aberto — o navegador so
// revalida em alguns casos (proxima navegacao/reload). Sem isso, quem ja
// tem o app instalado pode ficar preso numa versao antiga por muito tempo
// mesmo com skipWaiting + clientsClaim configurados no vite-plugin-pwa.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((reg) => {
    setInterval(() => reg.update(), 60_000);
  });

  // Quando o novo service worker assume o controle, recarrega uma vez pra
  // garantir que o app na tela bate com os assets que ele acabou de trocar.
  let reloadedAfterUpdate = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadedAfterUpdate) return;
    reloadedAfterUpdate = true;
    window.location.reload();
  });
}

export default app;
